import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoSituacaoMoradiaEnum } from 'graphql/types.generated'

import { tipoSituacaoMoradiaEnumRecord } from './condicoes-moradia-model'

type TipoSituacaoMoradiaSelectFieldProps = CustomSelectFieldProps<TipoSituacaoMoradiaEnum>

export function TipoSituacaoMoradiaSelectField(props: TipoSituacaoMoradiaSelectFieldProps) {
  return <SelectField<TipoSituacaoMoradiaEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.keys(tipoSituacaoMoradiaEnumRecord) as TipoSituacaoMoradiaEnum[]

const itemToString = (item: TipoSituacaoMoradiaEnum) => item && tipoSituacaoMoradiaEnumRecord[item]
